/********************************************************************
 * Project: WDCK（2021）
 * Class: CalendarComponent
 * ----------------------------------------
 * <summary>
 * CalendarComponent
 * </summary>
 * <history>
 *      ThaiTV     2021/07/27      Create
 * </history>
 ********************************************************************/
 import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
 import { NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
 import { TranslateService } from '@ngx-translate/core';
 import { LoadingService } from 'src/app/layout/loading/loading.service';
 import { Utility } from '../../utility/utility';
 import { CalendarService } from './calendar.service';
 
 @Component({
   selector: 'app-calendar',
   templateUrl: './calendar.component.html',
   styleUrls: ['./calendar.component.scss']
 })
 export class CalendarComponent implements OnInit, OnChanges {
   @Input() modelDate: any;
   @Input() classDate: any;
   @Output() eventClick = new EventEmitter<void>();
   ListNationalHoliday: any[] = [];
   @ViewChild(NgbDatepicker, { static: true }) datepicker: NgbDatepicker;
   constructor(
     public calendarService: CalendarService,
     private translate: TranslateService,
     private loadingSrv: LoadingService,
     private util: Utility
   ) { }
 
   ngOnInit(): void {
     this.loadingSrv.setDisplay(true);
     const strDefaultLang = this.translate.getDefaultLang();
     const objRequest = {
       Locale: strDefaultLang ? strDefaultLang : 'en',
     };
     this.calendarService.getNationalHoliday(objRequest).subscribe(data => {
       if (data && data.length > 0) {
         this.ListNationalHoliday = data;
       }
       this.loadingSrv.setDisplay(false);
     }, err => {
       this.loadingSrv.setDisplay(false);
     });
   }
 
   ngOnChanges(changes: SimpleChanges): void {
     if (!this.util.isNullOrEmpty(changes.modelDate) && !this.util.isNullOrEmpty(changes.modelDate.currentValue)) {
       this.datepicker.navigateTo(changes.modelDate.currentValue);
     }
   }
 
   getNationalHoliday(date) {
     if (this.ListNationalHoliday && this.ListNationalHoliday.length > 0) {
       const day = date.year.toString() + '-' + (date.month > 9 ? date.month.toString() : '0' + date.month.toString())
         + '-' + (date.day > 9 ? date.day.toString() : '0' + date.day.toString());
       const findDate = this.ListNationalHoliday.find(x => x.StartDate === day);
       return findDate ? true : false;
     } else {
       return false;
     }
   }
 
   selectDate(event) {
     this.eventClick.emit(event);
   }
 }
 